import { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

interface Props {
  onResult: (text: string) => void;
  onError?: (err: string) => void;
}

export function QRScanner({ onResult, onError }: Props) {
  const divId = 'vl-qr-' + Math.random().toString(36).slice(2);
  const scannerRef = useRef<Html5Qrcode | null>(null);

  useEffect(() => {
    const scanner = new Html5Qrcode(divId);
    scannerRef.current = scanner;
    let done = false;

    scanner.start(
      { facingMode: 'environment' },
      { fps: 10, qrbox: { width: 240, height: 240 } },
      (text) => { if (!done) { done = true; onResult(text); } },
      () => {}
    ).catch(err => onError?.(String(err)));

    return () => {
      scanner.stop().catch(() => {}).then(() => scanner.clear());
    };
  }, []);

  return <div id={divId} className="w-full" />;
}
